// ============================================================================
// LOGIN PAGE
// Initial authentication page with Cognito OAuth 2.0 redirect
// ============================================================================

import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #052831 0%, #063a47 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '60px 40px',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center',
        maxWidth: '450px',
        width: '100%'
      }}>
        <div style={{
          marginBottom: '30px'
        }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#052831',
            marginBottom: '10px'
          }}>
            Welcome to CCIP
          </h1>
          <p style={{
            fontSize: '16px',
            color: '#666',
            marginTop: '0'
          }}>
            Co-Creation Intelligence Platform
          </p>
        </div>

        <div style={{
          marginBottom: '30px',
          padding: '20px',
          background: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#495057',
            margin: '0',
            lineHeight: '1.6'
          }}>
            Sign in with your organization credentials to access collaborative workshop sessions, avatar management, and analytics.
          </p>
        </div>

        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '16px 24px',
            fontSize: '16px',
            fontWeight: '600',
            color: 'white',
            background: '#052831',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(5, 40, 49, 0.3)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#063a47';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(5, 40, 49, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = '#052831';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(5, 40, 49, 0.3)';
          }}
        >
          Sign In
        </button>

        <div style={{
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid #e9ecef'
        }}>
          <p style={{
            fontSize: '12px',
            color: '#868e96',
            margin: '0'
          }}>
            Secured by AWS Cognito
          </p>
        </div>
      </div>
    </div>
  );
}
